import { TrendingDown, Globe, Database, Users } from "lucide-react";

const benefits = [
	{
		icon: TrendingDown,
		title: "Reducción de Costos Operativos",
		description:
			"Automatiza hasta el 80% de las consultas frecuentes, disminuyendo la carga de trabajo de tus agentes y reduciendo significativamente los costos operativos.",
		color: "success",
	},
	{
		icon: Globe,
		title: "Atención en múltiples canales e idiomas",
		description:
			"Mantiene el mismo tono y coherencia en todos los canales (WhatsApp, redes sociales, correo, chat web), brindando una experiencia fluida, unificada y multilingüe.",
		color: "primary",
	},
	{
		icon: Database,
		title: "Información personalizada al instante",
		description:
			"Al conectarse con bases de datos internas, los asistentes brindan información actualizada sobre pedidos, reservas, facturas o stock en tiempo real.",
		color: "success",
	},
	{
		icon: Users,
		title: "Intervención humana cuando se requiere",
		description:
			"Si la consulta es compleja, el sistema la deriva a un agente humano con todo el contexto, evitando que el cliente repita información.",
		color: "primary",
	},
];

const Benefits = () => {
	return (
		<section className="py-16 px-4 sm:px-6">
			<div className="container mx-auto max-w-7xl">
				<div className="text-center mb-16">
					<h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
						Impacto en tu{" "}
						<span className="text-success">Negocio</span>
					</h2>
					<p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
						Beneficios tangibles que transforman tu operación
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					{benefits.map((benefit, index) => {
						const Icon = benefit.icon;
						const isSuccess = benefit.color === "success";

						return (
							<div
								key={index}
								className="group bg-card border border-border rounded-xl p-6 sm:p-8 hover:border-primary/50 transition-all duration-300 hover:shadow-xl"
							>
								<div className="flex flex-col sm:flex-row sm:items-start gap-6">
									<div
										className={`flex-shrink-0 w-14 h-14 rounded-lg ${
											isSuccess ? "bg-success/10" : "bg-primary/10"
										} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}
									>
										<Icon
											className={`h-7 w-7 ${
												isSuccess ? "text-success" : "text-primary"
											}`}
										/>
									</div>

									<div className="space-y-3 text-left sm:text-left">
										<h3
											className={`text-lg sm:text-xl font-bold ${
												isSuccess ? "text-success" : "text-primary"
											}`}
										>
											{benefit.title}
										</h3>
										<p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
											{benefit.description}
										</p>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default Benefits;
